/* src/app/shared/components/code-block/code-block.component.scss */
app-code-block {
  display: block;
  margin: 16px 0;
}
app-code-block .code-block {
  background: #24292e;
  border-radius: 10px;
  overflow: hidden;
  margin: 0;
  font-size: 13px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
}
app-code-block .code-block-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px;
  background: rgba(255, 255, 255, 0.06);
  color: #c9d1d9;
  font-family: "Inter Tight", sans-serif;
  font-size: 12px;
}
app-code-block .code-block-header .lang {
  text-transform: uppercase;
  letter-spacing: 0.05em;
  opacity: 0.6;
}
app-code-block .code-block-header .copy-btn {
  display: inline-flex;
  align-items: center;
  line-height: 1;
  gap: 5px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: #c9d1d9;
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 11px;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease;
}
app-code-block .code-block-header .copy-btn mat-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  height: 14px;
  width: 14px;
  line-height: 1;
}
app-code-block .code-block-header .copy-btn:hover {
  background: #e3fd64;
  border-color: #e3fd64;
  color: #1a1d23;
}
app-code-block .code-block-header .copy-btn.copied {
  background: rgba(22, 163, 74, 0.15);
  border-color: #16a34a;
  color: #4ade80;
}
app-code-block code {
  display: block;
  padding: 14px;
  overflow-x: auto;
  white-space: pre;
  font-family:
    "Consolas",
    "Monaco",
    monospace;
  line-height: 1.5;
}
/*# sourceMappingURL=code-block.component.css.map */
